<!--<label for="date">{{ labels[0] }}</label><br>
    <input type="text"
      placeholder="Klik om kalender te tonen.."
      class="form-control"
      [ngModel]="date"
      (ngModelChange)="dateChanged($event)"
      name="date"
      id="date"
      [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }"
      bsDatepicker>-->
<div fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="20px">
  <mat-form-field>
    <input
      matInput
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="datepicker"
      [placeholder]="labels[0]"
      [ngModel]="date"
      (ngModelChange)="dateChanged($event)"
      [disabled]="disabled"
    />
    <mat-datepicker-toggle matSuffix [for]="datepicker" [disabled]="disabled"></mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      [ngxTimepicker]="timepicker"
      [format]="24"
      name="timepicker"
      [placeholder]="labels[1]"
      [ngModel]="time"
      (ngModelChange)="timeChanged($event)"
      readonly
      [disabled]="disabled"
    />
    <ngx-material-timepicker #timepicker></ngx-material-timepicker>
  </mat-form-field>
</div>
